import createReactComponent from '../createReactComponent';
export default createReactComponent('mist', 'IconMist', [
  ['path', { d: 'M5 5h3m4 0h9', key: 'svg-0' }],
  ['path', { d: 'M3 10h11m4 0h1', key: 'svg-1' }],
  ['path', { d: 'M5 15h5m4 0h7', key: 'svg-2' }],
  ['path', { d: 'M3 20h9m4 0h3', key: 'svg-3' }],
]);
